import { render, staticRenderFns } from "./BannerCreateForm.vue?vue&type=template&id=4389d215&"
import script from "./BannerCreateForm.vue?vue&type=script&lang=js&"
export * from "./BannerCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports